import PosterPreview from "./PosterPreview";

export default PosterPreview;